import { formatDateLL } from "../../algorithms";
import { paths } from "../../paths/paths";

const RepliesCard = ({ reply, index, length }) => {
  return (
    <>
      <div
        key={reply.id}
        id={reply.id}
        className="d-flex   mt-3 justify-content-between "
      >
        <div className="d-flex align-items-center justify-content-start  col-md-9 ">
          <div
            style={{
              backgroundImage: `url("${paths.MemberPhoto}${reply.memberId}/${reply.memberPhoto}")`,
              width: 40,
              height: 40,
              borderRadius: "50%",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              border: "1px solid white",
            }}
          ></div>
          <p className="my-0 px-2" style={{ fontWeight: "bold", fontSize: 12 }}>
            {reply.memberName}
          </p>
        </div>
        <div className="d-flex align-items-center justify-content-center col-4">
          <div className="d-flex mb-2">
            <span className="text-muted" style={{ fontSize: 14 }}>
              {formatDateLL(reply.createDate)}
            </span>
          </div>
        </div>
      </div>

      <div className="  px-md-5 px-4 my-2 ">
        <div
          className="col-md-9 col-12 px-md-2"
          style={{
            textAlign: "justify",
            fontSize: 14,
            color: "#444444",
          }}
        >
          {reply.description}
        </div>
      </div>
      {index != length ? <hr className="m-3" /> : null}
    </>
  );
};

export default RepliesCard;
